import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class PaymentOrdersAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      code: '',
      date_start: '',
      type_options: [
        {value: 'Missão', label: this.locale.OrdensDePagamento.AdicionarOrdemDePagamento.opcoesTipo.Missao},
        {value: 'Treinamentos', label: this.locale.OrdensDePagamento.AdicionarOrdemDePagamento.opcoesTipo.Treinamentos},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // Setamos o state.date para a data de hoje
  componentWillMount () {
      var today = new Date().toISOString().slice(0,10);
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');

      this.setState({date_start: today_str});
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  loadData() {
    var today = new Date().toISOString().slice(0,10);
    var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');

    var datasave = {
      date_start: today_str,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordens/pagamento/codigo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({code: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      code: this.state.code,
      date_start: this.state.date_start,
      type: this.state.type,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordem/pagamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/ordem/pagamento/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.OrdensDePagamento.AdicionarOrdemDePagamento.titulo}</h3>
      <Link to="/ordens/pagamentos/abertas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.OrdensDePagamento.AdicionarOrdemDePagamento.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.OrdensDePagamento.AdicionarOrdemDePagamento.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                placeholder=""
                value={this.state.type}
                searchable={true}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.type_options}
                required
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.OrdensDePagamento.AdicionarOrdemDePagamento.formulario.Codigo}:</label>
              <input type="text" disabled="disabled" name="code" className="form-control" placeholder="" value={this.state.code} onChange={this.handleChange.bind(this, 'code')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.OrdensDePagamento.AdicionarOrdemDePagamento.formulario.botaoAdicionarOrdemDePagamento}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentOrdersAdd;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/PaymentOrdersAdd.js